import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import {Form} from '../modules/Form';
import {CommentsForm} from '../modules/CommentsForm';
import {CommentsItem} from '../modules/CommentsItem';

var Comments = class {
	constructor(wrapper) { 
		this._createElements(wrapper);
	}

	_createElements(wrapper){
        var self = this;
		this.wrapper = wrapper;
        this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.moduleAll = APP.modules.run(this.wrapper, 'data-comments-modules', this);
	}

    addNewComment(wrapper){ /*  */
        if(!this.moduleAll.CommentsItem)  this.moduleAll.CommentsItem = [];

        var obj = new CommentsItem(wrapper, this);
        this.moduleAll.CommentsItem.push(obj);

        return obj;
    }

    del(){
        APP.modules.destroy(this.moduleAll);
    }
};

export {Comments};





































